import { render, staticRenderFns } from "./RowBlockPartner.vue?vue&type=template&id=a1f9c708&"
import script from "./RowBlockPartner.vue?vue&type=script&lang=js&"
export * from "./RowBlockPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports